exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-dialog {\n  width: 50%;\n  max-width: 70%; }\n\n.modal-footer,\n.modal-body {\n  border-top: 1px solid #eceeef; }\n\n.modal-header {\n  padding: 10px 15px; }\n\n.modal-body {\n  padding: 25px 30px; }\n  .modal-body .has-feedback i {\n    top: 26px; }\n\n.pull-right {\n  float: right;\n  font-size: 16px;\n  color: #ec1c24;\n  cursor: pointer;\n  position: relative;\n  top: 20px; }\n\n.answer-block {\n  padding-top: 30px; }\n  .answer-block label {\n    width: 100%; }\n    .answer-block label.main-label {\n      font-size: 16px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/stranka/FrontOffice/src/app/modals/add-edit-survey-questions/add-edit-survey-questions.scss
// module id = ../../../../../src/app/modals/add-edit-survey-questions/add-edit-survey-questions.scss
// module chunks = main